export default {
  install: (app: any) => {
    // 使用 require.context 代替 import.meta.glob
    const requireComponent = require.context("./", true, /IndexView\.vue$/);
    requireComponent.keys().forEach((fileName: string) => {
      const names = fileName.split("/");
      if (names.length < 2) return;
      const name = names[1];
      // 可以在这里注册组件到 app
      app.component(name, requireComponent(fileName).default);
    });
  },
};
